export default "__VITE_ASSET__62fc1a1e__"